import { RefundChargebackReportListFilterValues } from 'pages/Finance/RefundChargebackReport/RefundChargebackReportFilter/RefundChargebackReportFilter';
import { DefaultValues } from 'react-hook-form';
import { getAppliedTimezone } from 'shared/mui/DatePicker/utils/getAppliedTimezone';
import { getId } from 'utils';
import { cleanEmpty } from 'utils/cleanEmpty';
import { formatInputToTimestamp } from 'utils/date';

export const transformFilterValues = (
  filterValues: DefaultValues<RefundChargebackReportListFilterValues>,
): RefundChargebackReportListFilterValues => {
  const {
    appliedDate = [null, null],
    updatedDate = [null, null],
    timezone = null,
    company = null,
    merchant = null,
    provider = null,
    conversionCurrency = null,
    summary = false,
    currency = [],
    merchantAccount = [],
    gateway = [],
    method = [],
    ...restFilters
  } = filterValues;

  return cleanEmpty({
    ...restFilters,
    createdAt: {
      gte: formatInputToTimestamp(appliedDate?.[0], { unit: 'seconds' }),
      lte: formatInputToTimestamp(appliedDate?.[1], { unit: 'seconds' }),
    },
    updatedAt: {
      gte: formatInputToTimestamp(updatedDate?.[0], { unit: 'seconds' }),
      lte: formatInputToTimestamp(updatedDate?.[1], { unit: 'seconds' }),
    },
    timezone: getAppliedTimezone(timezone, appliedDate, updatedDate),
    company: company ? getId(company) : null,
    merchant: merchant ? getId(merchant) : null,
    provider: provider ? getId(provider) : null,
    conversionCurrency: conversionCurrency && summary ? getId(conversionCurrency) : null,
    currency: currency?.map((item) => getId(item)),
    merchantAccount: merchantAccount?.map((item) => getId(item)),
    gateway: gateway?.map((item) => getId(item)),
    method: method?.map((item) => getId(item)),
    summary: summary ? '1' : null,
  });
};
